import {toast} from 'sonner';
import {tr} from '@/i18n/copy';
// Reuse TPS notifications for every multipart file upload, including updates.
// No payload, file data or upload history is persisted.
export function beginUpload(config) {
 if(!(config.data instanceof FormData)||config.__uploadNotice!==undefined)return config;
 const files=[...config.data.values()].filter(v=>v instanceof Blob);
 if(!files.length)return config;
 config.__uploadNotice=toast.loading(tr('Preparazione caricamento…'),{duration:Infinity});
 const previous=config.onUploadProgress;
 config.onUploadProgress=e=>{
  previous?.(e);
  const percent=e.total?Math.round(e.loaded/e.total*100):null;
  toast.loading(percent===100?tr('Verifica e archiviazione…'):`${tr('Caricamento…')}${percent!==null?' '+percent+'%':''}`,{id:config.__uploadNotice,duration:Infinity});
 };
 return config;
}
export function completeUpload(response){
 const id=response.config?.__uploadNotice;
 if(id!==undefined)toast.success(tr('Caricamento completato'),{id,duration:4000,style:{color:'rgb(16 185 129)',borderColor:'rgb(16 185 129 / .35)'}});
 return response;
}
export function failUpload(error){
 const id=error.config?.__uploadNotice;
 if(id!==undefined){if(error.code==='ERR_CANCELED')toast.dismiss(id);else toast.error(tr('Caricamento non completato. Controlla l’errore e riprova.'),{id,duration:6000});}
}
